module.exports = __webpack_public_path__ + "img/rightarrow.753bad45.svg";